import React from 'react';
import Button from '../Button';
import { BiSolidShareAlt } from 'react-icons/bi';

interface ShareButtonProps {
  onClick?: () => void;
  fillColor?: string;
  textButton?: string;
  id?: string
}

const ShareButton = ({
  onClick = () => {},
  fillColor = 'bg-reliableBlack80',
  textButton = '',
  id
}: ShareButtonProps & React.ComponentProps<'button'>) => {
  return (
    <Button
      id={id ? id : "btn-modal-share"}
      className="!p-0 !gap-x-0 !w-[40px] !h-[40px] lg:!w-[64px] lg:!h-[64px] lg:p-0"
      type="button"
      variant={'bg-[#E9E9E9]'}
      onClick={onClick}
      aria-label="share button"
    >
      {textButton} <BiSolidShareAlt className="w-6 h-6 lg:w-8 lg:h-8" fill={fillColor} />
    </Button>
  );
};

export default ShareButton;
